// extracted by mini-css-extract-plugin
export var breadcrumb = "styles-module--breadcrumb--PLnvp";
export var header = "styles-module--header--6bkk4";
export var holder = "styles-module--holder--xyAgY";
export var image = "styles-module--image--KblsW";
export var logoHolder = "styles-module--logoHolder--uSh1I";